import createModel from 'utils/model'
import {
    getAutoRelateSetting,
    setAutoRelateStatus,
    getAutoRelateUsers,
    getBindPhoneStatus,
    setBindPhoneStatus,
    getRelatePhoneStatus,
    setRelatePhoneStatus,
} from 'app-self-support-order/services/setting'

export default createModel({
    namespace: 'selfSupportOrder_setting',

    state: {
        autoRelateSettingObj: {},
        autoRelateUsers: [],
        bindPhoneObj: null, // 扩展资料中：自动绑定订单手机号
        relatePhoneObj: null, // 扩展资料中：自动关联订单手机号
    },

    effects: {
        *getAutoRelateSetting(xx, {call, put}) {
            const res = yield call(getAutoRelateSetting)
            yield put({
                type: 'setProperty',
                payload: {
                    autoRelateSettingObj: res.data,
                },
            })
        },

        *setAutoRelateStatus({payload}, {call}) {
            return yield call(setAutoRelateStatus, payload)
        },

        *getAutoRelateUsers(xx, {call, put}) {
            const res = yield call(getAutoRelateUsers, {config: 'import_auto_bind_status'})
            yield put({
                type: 'setProperty',
                payload: {
                    autoRelateUsers: res.data,
                },
            })
        },

        // 获取扩展资料中-自动绑定订单手机号-状态
        *getBindPhoneStatus(xx, {call, put}) {
            const res = yield call(getBindPhoneStatus)

            yield put({
                type: 'setProperty',
                payload: {
                    bindPhoneObj: res.data,
                },
            })
        },

        // 变更扩展资料中-自动绑定订单手机号-状态
        *setBindPhoneStatus({payload}, {call}) {
            return yield call(setBindPhoneStatus, payload)
        },

        // 获取扩展资料中-自动关联订单手机号-状态
        *getRelatePhoneStatus(xx, {call, put}) {
            const res = yield call(getRelatePhoneStatus)

            yield put({
                type: 'setProperty',
                payload: {
                    relatePhoneObj: res.data,
                },
            })
        },

        // 变更扩展资料中-自动关联订单手机号-状态
        *setRelatePhoneStatus({payload}, {call}) {
            return yield call(setRelatePhoneStatus, payload)
        },
    },
})
